var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoChannels(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 127,
    viewBox: "0 0 205 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M823 -258H-617V642H823V-258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 1,
    width: 112,
    height: 111
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103 112C133.928 112 159 87.1518 159 56.5C159 25.8482 133.928 1 103 1C72.0721 1 47 25.8482 47 56.5C47 87.1518 72.0721 112 103 112Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103 112C133.928 112 159 87.1518 159 56.5C159 25.8482 133.928 1 103 1C72.0721 1 47 25.8482 47 56.5C47 87.1518 72.0721 112 103 112Z",
    fill: "#F4F7FB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3913 53H77.6087C81.1385 53 84 55.6863 84 59C84 62.3137 81.1385 65 77.6087 65H48.3913C44.8615 65 42 62.3137 42 59C42 55.6863 44.8615 53 48.3913 53Z",
    fill: "#C9DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 74H64C67.866 74 71 77.134 71 81C71 84.866 67.866 88 64 88H8C4.13401 88 1 84.866 1 81C1 77.134 4.13401 74 8 74Z",
    fill: "#C9DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127 45H159C161.209 45 163 46.7909 163 49C163 51.2091 161.209 53 159 53H127C124.791 53 123 51.2091 123 49C123 46.7909 124.791 45 127 45Z",
    fill: "#C9DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106 7H199C202.314 7 205 9.68629 205 13C205 16.3137 202.314 19 199 19H106C102.686 19 100 16.3137 100 13C100 9.68629 102.686 7 106 7Z",
    fill: "#C9DBFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.3537 68.5151L87.8921 45.3843L87.146 44.6382L148.331 26.7305L152.061 27.4766L96.846 49.8612L108.784 61.0535L95.3537 68.5151Z",
    fill: "#E9E9F0",
    stroke: "#E9E9F0",
    strokeWidth: 1.18462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.146 44.6387L94.9995 69.5002L96.846 49.8617",
    stroke: "#E9E9F0",
    strokeWidth: 1.18462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.354 69.2614L108.039 61.0537",
    stroke: "#D4D9E0",
    strokeWidth: 1.18462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5927 69.5552L96.5005 50L110.277 61.8L95.3317 70.0416C94.9794 70.2359 94.5536 69.9557 94.5927 69.5552Z",
    fill: "#D4D9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 37.9231L87.1462 44.6385L163.254 23L67 37.9231Z",
    fill: "#B5BBC3",
    stroke: "#B5BBC3",
    strokeWidth: 1.18462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6369 39.4687L86.7993 44.5228C87.0253 44.5982 87.2687 44.6036 87.4979 44.5385L163.254 23L71.83 37.1742C70.6022 37.3646 70.4582 39.0758 71.6369 39.4687Z",
    fill: "#B5BBC3",
    stroke: "#B5BBC3",
    strokeWidth: 1.18462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.469 71.5L96.8462 49.8615L163.254 23L121.469 71.5Z",
    fill: "#B5BBC3",
    stroke: "#B5BBC3",
    strokeWidth: 1.18462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.711 70.8334L98.0641 50.9318C97.5051 50.4405 97.6593 49.5326 98.3492 49.2536L159.426 24.5482C160.399 24.1548 161.244 25.3332 160.559 26.1279L122.128 70.7349C121.765 71.1562 121.128 71.2005 120.711 70.8334Z",
    fill: "#B5BBC3",
    stroke: "#B5BBC3",
    strokeWidth: 1.18462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M88.1276 70C73.647 75 60.5874 105.232 110.127 88C121.627 84 126.875 87 131 91.5C145.5 110.5 84 130.5 63 125",
    stroke: "#8995A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "6 5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 122,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChannels);
export default __webpack_public_path__ + "static/media/NoChannels.5973fb04.svg";
export { ForwardRef as ReactComponent };